import React from 'react';
import { useLinks } from '../../hooks/useLinks';
import Buttons from '../Buttons';
import Links from '../Links';
import Logo from '../Logo';
import MobileNav from '../MobileNav';
import { Container, InnerNavWrapper, NavLogoWrapper } from './styled';
const Content = ({ logo, logoUrl, contrast, links, buttons, }) => {
    const allLinks = useLinks(links);
    return (React.createElement(InnerNavWrapper, null,
        React.createElement(Container, null,
            React.createElement(NavLogoWrapper, null,
                React.createElement(Logo, { logo: logo, contrast: contrast, logoUrl: logoUrl }),
                React.createElement(MobileNav, { contrast: contrast, links: allLinks, buttons: buttons })),
            React.createElement(Links, { contrast: contrast, links: allLinks })),
        React.createElement(Buttons, { contrast: contrast, buttons: buttons })));
};
export default Content;
//# sourceMappingURL=Content.js.map